export default "__VITE_ASSET__DyfBkIKv__"